import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';

import { useTranslations } from 'next-intl';

export const Price = ({ value = {}, min = 100, max = 20000, onChange }) => {
  const t = useTranslations();
  const minValue = value?.min || min;
  const maxValue = value?.max || max;

  return (
    <div className="pb-8">
      <div className="pt-8 pb-6 px-8">
        <div className="h-9" data-testid="slider-container">
          <Slider
            tabIndex={1}
            range
            value={[minValue, maxValue]}
            min={min}
            max={max}
            step={1}
            onChange={(value) =>
              onChange(
                value[0] <= min && value[1] >= max
                  ? { min: null, max: null }
                  : {
                      min: value[0],
                      max: value[1] >= max ? null : value[1],
                    },
              )
            }
            trackStyle={{ backgroundColor: '#0B6364', height: 4 }}
            railStyle={{ backgroundColor: '#CBD5E1', height: 4 }}
            handleStyle={{
              borderColor: 'transparent',
              opacity: 1,
              height: 36,
              width: 36,
              marginLeft: -16,
              marginTop: -16,
              backgroundColor: '#0B6364',
              boxShadow: 'none',
            }}
          />
        </div>
      </div>
      <div className="flex max-sm:flex-col max-sm:gap-[14px] sm:gap-[22px] w-full items-center">
        <div className="max-sm:w-full sm:flex-1 h-14 bg-slate-100 px-4 rounded-[10px] border border-slate-300 justify-start items-center gap-2.5 flex">
          <span className={`icon-input inline-flex text-[#33363F]`}>
            <i className="icon-arrow_alt_ldown text-[24px]" />
          </span>

          <div className="flex flex-col gap-1.5 w-full">
            <label className="text-xs text-slate-600 truncate inline-block h-[18px] mt-[-4px] mb-[-5px]">
              <span>{t('listings.filters.prices.minimum')}</span>
            </label>
            <input
              className={`font-medium inline-flex h-[19px] w-full mt-[-4px] mb-[-5px] placeholder:text-slate-400 bg-transparent focus:outline-none text-black max-sm:text-sm leading-[10px] input-location truncate search-item-input pr-6}`}
              value={`${minValue} SEK`}
              disabled
              data-testid="slider-value-min"
            />
          </div>
        </div>
        <div className="w-14 h-px relative border-b border-slate-300 max-sm:hidden" />
        <div className="max-sm:w-full sm:flex-1 h-14 bg-slate-100 px-4 rounded-[10px] border border-slate-300 justify-start items-center gap-2.5 flex">
          <span className={`icon-input inline-flex text-[#33363F]`}>
            <i className="icon-arrow_alt_ltop text-[24px]" />
          </span>

          <div className="flex flex-col gap-1.5 w-full">
            <label className="text-xs text-slate-600 truncate inline-block h-[18px] mt-[-4px] mb-[-5px]">
              <span>{t('listings.filters.prices.maximum')}</span>
            </label>
            <input
              className={`font-medium inline-flex h-[19px] w-full mt-[-4px] mb-[-5px] placeholder:text-slate-400 bg-transparent focus:outline-none text-black max-sm:text-sm leading-[10px] input-location truncate search-item-input pr-6}`}
              value={`${maxValue === max ? `${max}+` : maxValue} SEK`}
              disabled
              data-testid="slider-value-max"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
